<!-- HEADER -->
<app-header color="transparent"></app-header>

<!-- CONTENT -->
<ion-content class="padded">
  <!-- MAP -->
  <div class="map-wrapper">
    <app-mappedin *ngIf="showMap"></app-mappedin>
  </div>

  <!-- FOOTER -->
  <app-footer></app-footer>
</ion-content>
